import { CreateEligibility } from 'domain/usecases/eligibility/create-eligibility'
import { EligibilityRepository } from 'repository/interfaces/eligibility-repository'

export class RemoteCreateEligibility implements CreateEligibility {
  constructor(private readonly eligibilityRepository: EligibilityRepository) {}

  async create(
    params: CreateEligibility.Params
  ): Promise<CreateEligibility.Model> {
    return await this.eligibilityRepository.createEligibility(params)
  }
}

export type RemoteEligibilityCheckModel = CreateEligibility.Model
